import {
  getFormData,
  resetFormErrors,
  showFormErrors,
} from '../../utils/form';
import * as notification from '../../components/notifications';

const initPage = () => {
  const editProfileForm = $("#edit-profile-form");
  if (!editProfileForm.length) {
    return ;
  }

  editProfileForm.submit(() => {
    editProfile();

    return false;
  });

};

const getEditProfileData = () => {
  const form = $("#edit-profile-form");

  return getFormData(form);
};

const editProfile = async () => {
  const form = $("#edit-profile-form");
  const data = getEditProfileData();

  $('.btn-submit', form).loading();

  try {
    let response;
    response = await axios.patch("/api/users/current", data);

    resetFormErrors(form);
    notification.success(response.data.message);

    $('.btn-submit', form).loading(false);
  } catch (e) {
    console.log('error', e);

    $('.btn-submit', form).loading(false);

    showFormErrors(form, e.response);
  }
};

$(initPage);
